import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useModuleConfig } from '../context/ModuleConfigContext';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const { config } = useModuleConfig();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white py-4 mt-5">
      <Container>
        <Row>
          <Col md={6}>
            <h5>{config?.portal?.name || 'Kovvar B2B Portal'}</h5>
            <p>{config?.portal?.portalDescription || 'Dealer floor mat portal'}</p>
          </Col>
          <Col md={3}>
            <h5>Links</h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="/contact"
                  className="text-white text-decoration-none"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/contact';
                  }}
                >
                  {t('footer.contact')}
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  className="text-white text-decoration-none"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/terms';
                  }}
                >
                  {t('footer.terms')}
                </a>
              </li>
            </ul>
          </Col>
          <Col md={3}>
            <h5>Contact</h5>
            <address className="text-white">
              <small>
                Email: <a href={`mailto:${config?.portal?.infoMailAddress || 'sales@kovvar.com'}`} className="text-white">
                  {config?.portal?.infoMailAddress || 'sales@kovvar.com'}
                </a><br />
                Phone: {config?.portal?.phone || '038 20 22 835'}
              </small>
            </address>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <p className="text-center mb-0">
              <small>{t('footer.copyright', { 
                year: currentYear,
                portalName: config?.portal?.name || 'Kovvar B2B Portal'
              })}</small>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;